const slick = require('slick-carousel'); //TODO Use Glide instead of slick https://glidejs.com/
const arrow = '<svg><use xlink:href="' + site.theme_uri + '/assets/icons/icons.svg#sprite-arrow"></use></svg>';
const youtubeParams = '?rel=0?modestbranding=1&autohide=1&showinfo=0&controls=0&autoplay=1';
const youtubeIdRegExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

$('.section--video-slider').each(function () {
    let $this = $(this);
    let $slideContent = $this.find('.video-slider-content');
    let $videoSlider = $this.find('.video-slider__video-slides');
    let $textSlider = $this.find('.video-slider__text-slides');
    let $videoModal = $this.find('.video-modal');

    $slideContent.each(function () {
        let $thisContent = $(this);
        $videoSlider.append($thisContent.find('.v-slide--video'));
        $textSlider.append($thisContent.find('.v-slide--text'));
    });

    $videoSlider.slick({
        draggable: false
        , accessibility: false
        , arrows: false
        , asNavFor: $textSlider
        , fade: true
        , rows: 0
    });

    $textSlider.slick({
        infinite: true
        //, dots: true
        , prevArrow: '<button type="button" class="slick-prev">' + arrow + '<span class="sr-only">Previous</span></button>'
        , nextArrow: '<button type="button" class="slick-next">' + arrow + '<span class="sr-only">Next</span></button>'
        , asNavFor: $videoSlider
        , rows: 0
    });

    let $dots = $textSlider.find('.slick-dots button');
    $videoSlider.find('.v-slide').each(function (index) {
        let $thisSlide = $(this);
        let thumb = $thisSlide.attr('data-buttonthumb');
        $dots.eq(index).css('backgroundImage', 'url(' + thumb + ')');
    });
});

$('button[data-videourl]').each(function () {
    let $this = $(this);
    let $videoModal = $this.closest('section').find('.video-modal');
    let thisVideo = $this.attr('data-videourl');
    let thisvideoId = thisVideo.match(youtubeIdRegExp)[2];
    let thisEmbeddUrl = 'https://www.youtube.com/embed/' + thisvideoId + youtubeParams;
    $this.click(function (e) {
        $videoModal.find('iframe').attr('src', thisEmbeddUrl);
        $videoModal[0].showModal();
    });
});
